import React, { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import axios from "axios";
import { APIURL } from "../../../config";

const columns = [
    { field: "current_task", headerName: "Current Task", flex: 1.2, minWidth: 160 },
    { field: "workflow_name", headerName: "Workflow", flex: 1, minWidth: 140 },
    { field: "customer", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "assigned_to", headerName: "Assigned To", flex: 1, minWidth: 140 },
    { field: "days_open", headerName: "Days Open", type: "number", width: 110 },
    { field: "hours_open", headerName: "Hours Open", type: "number", width: 120 },
];

export default function BottleneckTasks(props) {
    const apiRef = useGridApiRef();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const compID = props.comp_id || (props.user && props.user.comp_id);
        if (!compID) {
            setLoading(false);
            return;
        }
        axios.get(APIURL + "/workflows/dashboard/bottleneck-tasks", {
            params: { compID }
        }).then((response) => {
            const data = Array.isArray(response.data) ? response.data : [];
            setRows(data);
            if (props.onRowCountChange) props.onRowCountChange(data.length);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }, [props.comp_id, props.user]);

    return (
        <Paper sx={{ height: "100%", display: "flex", flexDirection: "column", p: 1, pt: 0.5 }}>
            <Box sx={{ display: "flex", alignItems: "baseline", flexWrap: "wrap", columnGap: 1.5, mb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Bottleneck Tasks
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    Workflows where the current task is open — one row per open task in an active instance, ordered by how long it has been open (longest first).
                </Typography>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <DataGridPro
                    apiRef={apiRef}
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    loading={loading}
                    density="compact"
                    disableRowSelectionOnClick
                />
            </Box>
        </Paper>
    );
};
